module.exports = __webpack_public_path__ + "static/media/Neutral.47483d2e.png";